import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  padding: 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* height: 100%; */

  background-color: ${({ theme }) => theme.background};
  /* margin: 0 15vw; */

  @media (min-width: 996px) {
    > p {
      display: none;
    }
  }

  @media (max-width: 996px) {
    margin-top: 2rem;
    width: 100vw;

    > p {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      width: 100%;
      color: #fff;
      margin-top: auto;

      svg {
        margin-left: 8px;
        transform: rotateX(180deg);
      }
    }
  }
`;

export const GameContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;

  max-width: calc(100vw - 21vw);

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    width: 100vw;
    background-color: rgb(84, 173, 72);
    color: #fff;

    @media (max-width: 720px) {
      font-size: 1.25rem;
    }
  }

  @media (min-width: 996px) {
    > button {
      display: none;
    }
    &::before {
      content: '';
      width: 100%;
      height: 1.25rem;
      background: #9fa7f7;
    }
  }

  div {
    display: flex;
  }
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;

  @media (max-width: 900px) {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }

  @media (min-width: 550px) and (max-height: 600px) and (max-width: 900px) {
    min-height: 600px;
    overflow: scroll;
  }

  @media (min-width: 900px) and (max-height: 480px) {
    min-height: 480px;
    overflow: scroll;
  }

  @media (max-width: 550px) and (max-height: 600px) {
    min-height: 600px;
    overflow: scroll;
  }
`;

export const GameContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 20px 0;

  @media (max-width: 900px) {
    width: 100%;
    padding: 20px 30px;
  }

  @media (max-width: 550px) {
    width: 100%;
    padding: 15px 6px;
  }
`;
